<template>
  <!-- 部门选择组件，只能用于选择单个部门，不能用于其它情况 -->
  <div class="depart-select">
    <span v-if="disabled">
      <slot>{{departName}}</slot>
    </span>
    <el-tree-select v-else v-model="dataValue" :data="dataList" default-expand-all check-strictly @change="changeDataValue"
                    :render-after-expand="false" :placeholder="placeholder" :clearable="clearable"
                    :props="{children: 'children', label: 'departName', disabled: 'disabled'}" node-key="departCode">
      <template #prefix>
        <slot name="prefix"/>
      </template>
    </el-tree-select>
  </div>
</template>

<script>


import {watch} from "vue";
import util from "@/util/util";

export default {
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    clearable: { // 是否可清空
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "请选择所属部门",
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: "",
  components: {
  },
  data() {
    return {
      dataValue: "",
      dataList: [],
      userInfo: {},
      departName: "",
    };
  },
  async created() {
    this.userInfo = await util.getUserInfo();
    this.initDepart();
    this.initValue();
    watch(() => this.modelValue, () => {
      this.initValue();
    })
    watch(() => this.data, () => {
      this.initValue();
      this.initDepart();
    })
  },
  methods: {
    initValue() {
      this.dataValue = this.modelValue;
      // 如果只读，获取部门名称
      if (this.disabled) {
        this.departName = this.findDepartName(this.data, this.dataValue);
      }
    },
    findDepartName(list, val) {
      if (!list || !list.length) {
        return "";
      }
      for (let i = 0; i < list.length; i++) {
        if (list[i].departCode === val) {
          return list[i].departName;
        }
        if (list[i].children) {
          let name = this.findDepartName(list[i].children, val);
          if (name) {
            return name;
          }
        }
      }
      return "";
    },
    initDepart() {
      let arr = [...this.data];
      this.initList(arr);
      this.dataList = arr;
    },
    initList(list) {
      // 这些depart禁用，不能被选中
      for (let i = 0; i < list.length; i++) {
        if (!list[i].departCode) {// 编号不存在
          list[i].disabled = true; // 禁止选择
        } else if (!list[i].departCode.startsWith(this.userInfo.mainDepartCode)) { // 不是用户的主部门下的数据
          list[i].disabled = true; // 禁止选择
        }
        if (list[i].children && list[i].children.length > 0) {
          this.initList(list[i].children);//下级遍历
        }
      }
    },
    changeDataValue() {
      this.$emit("update:modelValue", this.dataValue);
    }
  }
};
</script>

<style lang="scss" scoped>

</style>